/**
 * Multi-column 响应式功能模块
 * 功能：处理 multi-column 组件的响应式行为和 hover 交互
 * 特性：
 * - 设备检测（移动端/桌面端）
 * - Hover 交互处理
 * - 动态 CSS 类管理
 * - 窗口大小变化监听
 * - DOM 变化监听
 */
"use strict";

document.addEventListener('DOMContentLoaded', function () {
  let resizeTimeout;

  // 设备检测函数
  function isMobileDevice() {
    return window.innerWidth <= 768;
  }

  // 处理multi-column组件的hover交互
  function initMultiColumnHover() {
    const multiColumnItems = document.querySelectorAll('.multi-column__grid-item');

    multiColumnItems.forEach(item => {
      const imageWrapper = item.querySelector('.multi-column__grid-item-image-wrapper');
      const overlayContent = item.querySelector('.overlay-content');
      const enableHoverOverlay = item.querySelector('[data-enable-hover-overlay]')?.getAttribute('data-enable-hover-overlay') === 'true';

      if (imageWrapper && overlayContent && enableHoverOverlay) {
        const isMobile = isMobileDevice();

        if (!isMobile) {
          // 桌面端hover交互
          // 当hover在image-wrapper上时，显示overlay-content
          imageWrapper.addEventListener('mouseenter', function () {
            overlayContent.style.opacity = '1';
            imageWrapper.classList.add('hover-active');
          });

          imageWrapper.addEventListener('mouseleave', function () {
            overlayContent.style.opacity = '0';
            imageWrapper.classList.remove('hover-active');
          });

          // 当hover在overlay-content上时，保持overlay-content显示并显示image-wrapper的::before
          overlayContent.addEventListener('mouseenter', function () {
            overlayContent.style.opacity = '1';
            // 通过添加一个类来触发::before的显示
            imageWrapper.classList.add('hover-active');
          });

          overlayContent.addEventListener('mouseleave', function () {
            overlayContent.style.opacity = '0';
            imageWrapper.classList.remove('hover-active');
          });
        } else {
          // 移动端：文本直接显示在图片下面，不需要hover交互
          // 确保文本内容可见
          overlayContent.style.opacity = '1';
        }
      }
    });
  }

  // 动态设置multi-column文本容器的CSS类
  function updateMultiColumnTextContainers() {
    const textContainers = document.querySelectorAll('.multi-column__grid-item-text-container');
    const isMobile = isMobileDevice();

    textContainers.forEach(container => {
      const enableHoverOverlay = container.getAttribute('data-enable-hover-overlay') === 'true';
      if (enableHoverOverlay) {
        // 移除现有的类
        container.classList.remove('section', 'multi-column-padding-top', 'overlay-content');

        // 移除所有overlay-position类
        const overlayPositionClasses = container.className.match(/overlay-position-\w+/g) || [];
        overlayPositionClasses.forEach(className => {
          container.classList.remove(className);
        });
        // 根据设备类型添加相应的类
        if (isMobile) {
          // 移动端：使用section和multi-column-padding-top类
          container.classList.add('section', 'multi-column-padding-top');
          // 移除overlay相关的属性
          container.removeAttribute('data-overlay');
        } else {
          // 桌面端：使用overlay-content类
          container.classList.add('overlay-content');
          // 添加overlay属性
          container.setAttribute('data-overlay', 'true');

          // 检查是否有位置配置
          const overlayPosition = container.getAttribute('data-overlay-position') || 'center';
          container.classList.add(`overlay-position-${overlayPosition}`);
        }
      }
    });
  }

  // 初始化
  function initMultiColumn() {
    initMultiColumnHover();
    updateMultiColumnTextContainers();
  }

  // 初始化
  initMultiColumn();

  // 监听窗口大小变化（使用防抖）
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function () {
      initMultiColumn();
    }, 250); // 250ms防抖
  });

  // 监听动态内容变化（如果有AJAX加载的内容）
  const observer = new MutationObserver(function (mutations) {
    let shouldUpdate = false;

    mutations.forEach(function (mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        // 检查是否有新的multi-column项目被添加
        const hasNewMultiColumn = Array.from(mutation.addedNodes).some(node => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            return node.querySelector('.multi-column__grid-item') ||
              node.classList.contains('multi-column__grid-item');
          }
          return false;
        });

        if (hasNewMultiColumn) {
          shouldUpdate = true;
        }
      }
    });

    if (shouldUpdate) {
      initMultiColumn();
    }
  });

  // 开始观察
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

